import ApiClient from "./ApiClient"

import User from "../types/User";
import LockingSystemPermission from "../types/LockingSystemPermission"

import {UserLockingSystemPermissionAdd} from "@customTypes/UserLockingSystemPermission"

export const UserLockingSystemPermissionApi = {

    apiPath: 'user-locking-system-permissions',

    add: async (userLockingSystemPermissions: UserLockingSystemPermissionAdd): Promise<any> => {

        const result = await ApiClient.post(
            'users/' + userLockingSystemPermissions.userId
            + '/locking-system-permissions'
            + '?lockingSystemId=' + userLockingSystemPermissions.lockingSystemId,
            userLockingSystemPermissions
        )

        return result.data?.data
    },

    delete: async (user: User, lockingSystemPermission: LockingSystemPermission): Promise<any> => {

        return await ApiClient.delete('users/' + user.id
            + '/locking-system-permissions/' + lockingSystemPermission.id
            + '?lockingSystemId=' + lockingSystemPermission.lockingSystemId
        )

    },

    deleteAll: async (user: User, lockingSystemId: number): Promise<any> => {

        return await ApiClient.delete('users/' + user.id
            + '/locking-system-permissions/all'
            + '?lockingSystemId=' + lockingSystemId
        )

    },

}

export default UserLockingSystemPermissionApi